import { Observable } from 'rxjs/Observable';
import { Visit } from '../../models/visit.model';
import { BaseCondition } from "./base.condition";
import { NotificationService } from '../../services';
import { ConditionFailReason } from '../../models';

export class TimeSinceLastVisitByPageCondition extends BaseCondition {
  constructor(path: string, visits: Visit[], options: any, notificationService: NotificationService) {
    super("TimeSinceLastVisitByPageCondition",notificationService);
    console.log('Time Since Last Visit By Page Condition called');
    let result: boolean = false;
    if (options.hasOwnProperty('Min')) {
      console.log(`TimeSinceLastVisitByPageCondition :  Configuration parameter Min is ${options.Min} Minutes`);
      if (path) {
        console.log(`TimeSinceLastVisitByPageCondition : page path is ${path}`);
        const pageLastVisits = visits.filter(x => x.hasOwnProperty('TimeStamp') && x.TimeStamp <= Date.now() && x.Path === path);
        if (pageLastVisits && pageLastVisits.length == 1) {
          console.log(`TimeSinceLastVisitByPageCondition :  first visit hence condition is returning true`);
          console.info("TimeSinceLastVisitByPageCondition condition passed!!");
          result = true;
        }
        else {
          if (pageLastVisits && pageLastVisits.length > 1) {
            let diffFromLastVisit = (pageLastVisits[pageLastVisits.length - 1].TimeStamp - pageLastVisits[pageLastVisits.length - 2].TimeStamp);
            const threshold: number = options.Min * 60 * 1000;
            result = (diffFromLastVisit >= threshold);
            console.log(`TimeSinceLastVisitByPageCondition :  time since last visit is ${diffFromLastVisit} Milliseconds`);
            if (result)
              console.info("TimeSinceLastVisitByPageCondition condition passed!!");
            else
              this.onConditionFail(ConditionFailReason.CriteriaFail, "TimeSinceLastVisitByPageCondition condition failed!!");
          }
        }
      }
      else {
        this.onConditionFail(ConditionFailReason.CriteriaFail,`TimeSinceLastVisitByPageCondition :  page path is not available`);
        console.info("TimeSinceLastVisitByPageCondition condition failed!!");
        result = false;
      }
    } else {
      this.onConditionFail(ConditionFailReason.ConfigurationError, `TimeSinceLastVisitByPageCondition :  Configuration error parameter Min missing`);
      console.info("TimeSinceLastVisitByPageCondition condition failed!!");
      result = false;
    }
      this.observable = new Observable(observer => {
          observer.next(result);
      });
  }
}
